export const getFileTypeName = (type) => {
  switch (type) {
    case 'file':
      return 'Arquivo';
    case 'image':
      return 'Imagem';
    case 'audio':
      return 'Áudio';
    case 'video':
      return 'Vídeo';
    case 'sticker':
      return 'Figurinha';
    default:
      return 'Desconhecido';
  }
};
